import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailCommandActions" */ './lazyIndex'),
    { name: 'MailCommandActions' }
);

export const lazyOnClearMsgPermissions: LazyAction<
    typeof lazyIndex.onClearMsgPermissions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onClearMsgPermissions);
export const lazyOnCopyToClipboard: LazyAction<
    typeof lazyIndex.onCopyToClipboard,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onCopyToClipboard);
export const lazyOnDelete: LazyAction<typeof lazyIndex.onDelete, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onDelete);
export const lazyOnFlagUnflag: LazyAction<typeof lazyIndex.onFlagUnflag, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onFlagUnflag);
export const lazyOnMarkAsReadUnread: LazyAction<
    typeof lazyIndex.onMarkAsReadUnread,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onMarkAsReadUnread);
export const lazyOnResponse: LazyAction<typeof lazyIndex.onResponse, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onResponse);
export const lazyOnSensitivity: LazyAction<typeof lazyIndex.onSensitivity, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onSensitivity);
export const lazyOnToggleMessageClassification: LazyAction<
    typeof lazyIndex.onToggleMessageClassification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onToggleMessageClassification);
export const lazyOnToggleRmsTemplate: LazyAction<
    typeof lazyIndex.onToggleRmsTemplate,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onToggleRmsTemplate);
export const lazyOnSensitivityLabelChanged: LazyAction<
    typeof lazyIndex.onSensitivityLabelChanged,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onSensitivityLabelChanged);

// non lazy exports
export { ResponseType } from './enums/ResponseType';
